import { leagueFetch } from '@leagueplatform/league-fetch';

const USER_API = '/v1/users';

export async function deleteUserAccount(userId: string): Promise<boolean> {
  const response = await leagueFetch(`${USER_API}/${userId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error(`Failed to delete account: ${response.status}`);
  }
  return response.ok;
}
